// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-card .van-row[data-v-766e9d0a] {\n  margin-bottom: 0.53333rem;\n}\n.data-card .label[data-v-766e9d0a] {\n  font-size: 0.42667rem;\n  line-height: 1.06667rem;\n  color: #8c8c8c;\n}\n.data-card .value[data-v-766e9d0a] {\n  font-size: 0.8rem;\n  line-height: 1.06667rem;\n  color: #262626;\n}\n", ""]);
// Exports
module.exports = exports;
